import Home from "@/components/Home";
import Manage from "@/components/Manage/Manage";

export default [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: { name: "Manage", params: { slug: "updates" } },
    children: [
      {
        path: "/page/:slug",
        name: "Manage",
        component: Manage
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js